import React, { useMemo } from 'react';
import { LayersControl, TileLayer, useMapEvents } from 'react-leaflet';

const STORAGE_KEY = 'ktc_leaflet_base_layer';

const TILE_SOURCES = [
  {
    id: 'default',
    label: 'Default',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenStreetMap contributors',
  },
  {
    id: 'light',
    label: 'Terang',
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
  },
  {
    id: 'satellite',
    label: 'Satelit',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri',
  },
  {
    id: 'dark',
    label: 'Gelap',
    url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
  },
];

const readPreferredLayer = () => {
  try {
    const raw = String(localStorage.getItem(STORAGE_KEY) || '').trim().toLowerCase();
    if (TILE_SOURCES.some((item) => item.id === raw)) {
      return raw;
    }
  } catch {
    // ignore localStorage errors
  }
  return 'dark';
};

const LayerPreferenceSync = () => {
  useMapEvents({
    baselayerchange: (event) => {
      const selectedLabel = String(event?.name || '').trim().toLowerCase();
      const match = TILE_SOURCES.find((item) => item.label.toLowerCase() === selectedLabel);
      if (!match) return;
      try {
        localStorage.setItem(STORAGE_KEY, match.id);
      } catch {
        // ignore localStorage errors
      }
    },
  });
  return null;
};

const LeafletTileLayer = () => {
  const preferredLayer = useMemo(() => readPreferredLayer(), []);

  return (
    <>
      <LayersControl position="topright">
        {TILE_SOURCES.map((source) => (
          <LayersControl.BaseLayer
            key={source.id}
            name={source.label}
            checked={source.id === preferredLayer}
          >
            <TileLayer attribution={source.attribution} url={source.url} />
          </LayersControl.BaseLayer>
        ))}
      </LayersControl>
      <LayerPreferenceSync />
    </>
  );
};

export default LeafletTileLayer;
